module.exports = __webpack_public_path__ + "img/mia-post1.3a60cc76.jpeg";